import { InjectionToken } from '@angular/core';

/**
 * Legal URLs rendered by {@link TermsAgreementDisclaimerComponent}. Provided per
 * application from its brand config so the disclaimer never has to be told which
 * brand it is rendering for. Individual `@Input()`s still override these.
 */
export interface TermsDisclaimerUrls {
  main: string;
  /** Display text for the `main` link, e.g. "Deleteme.com". */
  mainLabel: string;
  terms: string;
  refund: string;
  privacy: string;
  ownDataSearches: string;
  thirdPartySearches: string;
}

export const TERMS_DISCLAIMER_URLS = new InjectionToken<TermsDisclaimerUrls>('TERMS_DISCLAIMER_URLS');
